import Bestellung from "@/entities/common/bestellung"
import BstlArtikel from "@/entities/common/bstl_artikel"
import { Bezahlart, LoadState, Terminart } from "@/entities/common/enums"
import BPAufgebenRequest from "@/entities/common/pending/bp_aufgeben_request"
import RemoteResult from "@/entities/common/remote_result"
import router from "@/router"
import BestellungPending, {
  Abholung,
  Reservierung,
  Sofortbestellung,
} from "@/entities/common/bestellung_pending"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"
import vuexStore from "@/store"

export default class BestaetigenLogic extends BaseLogic {
  bestaetigenLoadState: string = LoadState.IDLE
  bestellung: Bestellung = null
  warenkorb: BstlArtikel[] = []
  terminart: string = null
  bezahlart: string = null
  agbAkzeptiert: boolean = false

  abholungData: Abholung
  reservierungDate: Reservierung
  sofortData: Sofortbestellung

  init() {
    this.mainLogic.bestellungPendingListeners.push(() => {
      var nbd = this.mainLogic.bestellungPending
      this.bezahlart = nbd.bezahlart

      this.warenkorb = nbd.artikelliste
      this.terminart = nbd.terminart

      if (this.terminart === Terminart.ABHOLUNG) {
        this.abholungData = nbd.abholung
      } else if (this.terminart === "RESERVIERUNG") {
        this.reservierungDate = nbd.reservierung
      } else if (this.terminart === "SOFORTBESTELLUNG") {
        this.sofortData = nbd.sofort
      }
    })

    var nbd = this.mainLogic.bestellungPending
    this.bezahlart = nbd.bezahlart

    this.warenkorb = nbd.artikelliste
    this.terminart = nbd.terminart

    if (this.terminart === Terminart.ABHOLUNG) {
      this.abholungData = nbd.abholung
    } else if (this.terminart === "RESERVIERUNG") {
      this.reservierungDate = nbd.reservierung
    } else if (this.terminart === "SOFORTBESTELLUNG") {
      this.sofortData = nbd.sofort
    }
  }

  agbAnzeigen() {
    router.push({ name: RouteNames.AGB })
  }

  bestellungBestaetigen() {
    if (this.bezahlart == Bezahlart.PAYPAL) {
      router.push({ name: RouteNames.NEU.TRINKGELD })
      return
    }

    this.bestaetigenLoadState = LoadState.LOADING

    var request = new BPAufgebenRequest()
    request.bestellungId = vuexStore.state.user.identifier
    request.bezahlart = this.bezahlart

    Poster.postUser<RemoteResult<Bestellung>>(
      RestPaths.bestellungpendingAufgeben,
      request
    )
      .then((response) => {
        if (response.data.success) {
          var dto = response.data.payload

          this.mainLogic.bestellung = dto
          this.mainLogic.bestellungPending = new BestellungPending()
          this.mainLogic.neueBestellung = false

          if (dto.bezahlart == Bezahlart.PAYPAL) {
            router.push({
              name: RouteNames.NEU.BEZAHLUNG_WEITERLEITEN,
              params: {
                bestellungId: dto.id,
              },
            })
            return
          }

          router.push({
            name: RouteNames.BESTELLUNG_PAGE.DETAILS,
            params: { bestellungId: dto.id },
          })
        } else {
          this.bestaetigenLoadState = LoadState.ERROR
        }
      })
      .catch(() => {
        this.bestaetigenLoadState = LoadState.ERROR
      })
  }
}
